// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-dropdown .trigger {
  position: relative;
  box-shadow: 0px 8px 16px var(--dark-yellow);
  border-radius: 22px;
}

.language-dropdown .trigger span {
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  background: var(--yellow);
  color: var(--dark-green);
  min-width: 0px;
  height: 44px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 22px;
  transition:
    350ms border-radius 700ms,
    700ms color 700ms,
    350ms min-width 700ms;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.language-dropdown .trigger ul.languages {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: var(--yellow);
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaleY(0);
  transform-origin: top;
  transition: 350ms transform 350ms;
}

.language-dropdown .trigger ul.languages a {
  opacity: 0;
  transition: 350ms opacity 0ms;
}

.language-dropdown .trigger ul.languages li {
  top: 0;
  left: 0;
  width: 220px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid var(--green);
  transition: 200ms border-left 0ms;
  color: var(--green);
}

.language-dropdown .trigger ul.languages li:before {
  content: "";
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, var(--dark-green), var(--green));
  position: absolute;
  top: 0;
  left: 0;
}

.language-dropdown .trigger ul.languages li:last-of-type {
  border-radius: 0 0 22px 22px;
}

.language-dropdown .trigger ul.languages li:hover {
  border-left: 10px solid var(--dark-green);
  color: var(--dark-green);
}

.language-dropdown .trigger:hover span {
  min-width: 220px;
  border-radius: 22px 22px 0 0;
  transition:
    350ms border-radius 0ms,
    700ms color 700ms,
    350ms min-width 0ms;
  color: var(--green);
}

.language-dropdown .trigger:hover ul.languages {
  transform: scaleY(1);
  transition: 350ms transform 350ms;
}

.language-dropdown .trigger:hover ul.languages a {
  opacity: 1;
  transition: 350ms opacity 700ms;
}
`, "",{"version":3,"sources":["webpack://./packages/studytour-io-app/src/components/LanguageButton.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB;;;yBAGuB;EACvB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,MAAM;EACN,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,sEAAsE;EACtE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B;;;uBAGqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC","sourcesContent":[".language-dropdown .trigger {\n  position: relative;\n  box-shadow: 0px 8px 16px var(--dark-yellow);\n  border-radius: 22px;\n}\n\n.language-dropdown .trigger span {\n  font-weight: 500;\n  letter-spacing: 0px;\n  font-size: 16px;\n  position: relative;\n  background: var(--yellow);\n  color: var(--dark-green);\n  min-width: 0px;\n  height: 44px;\n  padding: 0 18px;\n  z-index: 1;\n  cursor: pointer;\n  border-radius: 22px;\n  transition:\n    350ms border-radius 700ms,\n    700ms color 700ms,\n    350ms min-width 700ms;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.language-dropdown .trigger ul.languages {\n  position: absolute;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background: var(--yellow);\n  border-radius: 0 0 22px 22px;\n  font-size: 14px;\n  overflow: hidden;\n  transform: scaleY(0);\n  transform-origin: top;\n  transition: 350ms transform 350ms;\n}\n\n.language-dropdown .trigger ul.languages a {\n  opacity: 0;\n  transition: 350ms opacity 0ms;\n}\n\n.language-dropdown .trigger ul.languages li {\n  top: 0;\n  left: 0;\n  width: 220px;\n  height: 44px;\n  padding: 0 20px;\n  z-index: 0;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-left: 0px solid var(--green);\n  transition: 200ms border-left 0ms;\n  color: var(--green);\n}\n\n.language-dropdown .trigger ul.languages li:before {\n  content: \"\";\n  width: 100%;\n  height: 1px;\n  background: linear-gradient(to right, var(--dark-green), var(--green));\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.language-dropdown .trigger ul.languages li:last-of-type {\n  border-radius: 0 0 22px 22px;\n}\n\n.language-dropdown .trigger ul.languages li:hover {\n  border-left: 10px solid var(--dark-green);\n  color: var(--dark-green);\n}\n\n.language-dropdown .trigger:hover span {\n  min-width: 220px;\n  border-radius: 22px 22px 0 0;\n  transition:\n    350ms border-radius 0ms,\n    700ms color 700ms,\n    350ms min-width 0ms;\n  color: var(--green);\n}\n\n.language-dropdown .trigger:hover ul.languages {\n  transform: scaleY(1);\n  transition: 350ms transform 350ms;\n}\n\n.language-dropdown .trigger:hover ul.languages a {\n  opacity: 1;\n  transition: 350ms opacity 700ms;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
